<template>
    <div class="main">
        <div class="title">
            <h4>{{ teamStore.getTeamName }}</h4>
        </div>
        <div class="row space-between">
            <div>
                <input v-model="state.title" type="text" placeholder="Choose a Title" class="title-input" />
            </div>
            <div class="buttons">
                <router-link :to="{ name: 'Home' }">
                    <button class="danger-button bt" title="Discard">
                        <font-awesome-icon :icon="['fas', 'times']" />
                    </button>
                </router-link>
                <button @click.once="save" class="action-button" title="Save">
                    <font-awesome-icon :icon="['fas', 'save']" />
                </button>
            </div>
        </div>
        <div class="text-editor">
            <TextEditorSkeleton v-if="state.loading" :showToolbar="true" />
            <RichTextBox v-else v-model="state.value" />
        </div>
    </div>
</template>

<script setup lang="ts">
import RichTextBox from "@/components/RichTextBox.vue";
import { TeamStory } from "@/services/entities/teamStory";
import { useTeamStoryStore } from "@/stores/teamStory";
import { onMounted, reactive } from "vue";
import { onBeforeRouteLeave } from "vue-router";
import router from "@/router";
import { useTeamStore } from "@/stores/team";
import { toast } from "vue3-toastify";
import TextEditorSkeleton from "@/components/util/TextEditorSkeleton.vue";

const teamStoryStore = useTeamStoryStore();
const teamStore = useTeamStore();

const props = defineProps<{
    template: string;
}>();

onMounted(async () => {
    state.loading = true;
    await teamStoryStore.loadTemplate(props.template);
    state.title = teamStoryStore.getTemplate?.heading ?? "";
    state.value = teamStoryStore.getTemplate?.body ?? "";
    state.loading = false;
});

const state = reactive({
    value: "",
    title: "",
    saved: false,
    loading: true,
});

async function save() {
    let story = {
        heading: state.title,
        body: state.value,
        tags: teamStoryStore.getTemplate.tags,
    } as any as TeamStory;
    const t = toast.loading("Saving...");

    await teamStoryStore.createTeamStory(props.template, story);

    state.saved = true;
    toast.remove(t);
    toast.success("Saved!");
    setTimeout(() => {
        router.push({ name: "Home" });
    }, 1000);
}

onBeforeRouteLeave((to, from, next) => {
    if (!state.saved && !confirm("Discard changes?")) {
        next(false);
    } else {
        next();
    }
});
</script>

<style lang="scss" scoped>
.main {
    display: flex;
    flex-direction: column;
    padding-top: 30px;
}

.text-editor {
    margin-top: 5px;
    width: 100%;
    height: 100%;
}

.buttons {
    display: flex;
    gap: 10px;
    padding-right: 3px;
}

.row {
    display: flex;
    flex-direction: row;
    width: 100%;

    &.space-between {
        justify-content: space-between;
    }
}

.row-right {
    display: flex;
    margin-top: 10px;
    align-items: right;
    justify-content: right;
}

.bt {
    margin-right: 5px;
}
</style>
